var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.809,
    height: 17.724,
    viewBox: "0 0 21.809 17.724",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-tw"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_Compound_Clipping_Path_",
    "data-name": "<Compound Clipping Path>",
    d: "M2410.416,2848.075a12.644,12.644,0,0,0,12.731-12.731q0-.291-.013-.578a9.118,9.118,0,0,0,2.232-2.317,8.927,8.927,0,0,1-2.57.7,4.489,4.489,0,0,0,1.968-2.475,8.97,8.97,0,0,1-2.841,1.086,4.479,4.479,0,0,0-7.625,4.081,12.7,12.7,0,0,1-9.223-4.675,4.476,4.476,0,0,0,1.385,5.973,4.44,4.44,0,0,1-2.027-.56c0,.019,0,.037,0,.057a4.476,4.476,0,0,0,3.59,4.386,4.464,4.464,0,0,1-2.021.077,4.479,4.479,0,0,0,4.18,3.108,9.049,9.049,0,0,1-6.625,1.853,12.668,12.668,0,0,0,6.859,2.01",
    transform: "translate(-2403.557 -2830.35)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.918,
    cy: 0.093,
    r: 1.164,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_48332",
    "data-name": "Group 48332",
    clipPath: "url(#clip-path-tw)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACK",
    transform: "translate(-7.656 -9.699)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACK-2",
    "data-name": "BACK"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15428",
    "data-name": "Rectangle 15428",
    width: 37.122,
    height: 37.122,
    rx: 18.561,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15429",
    "data-name": "Rectangle 15429",
    width: 37.122,
    height: 37.122,
    rx: 18.561,
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "COLOR"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15430",
    "data-name": "Rectangle 15430",
    width: 37.122,
    height: 37.122,
    rx: 18.561,
    fill: "#1da1f2",
    style: {
      mixBlendMode: "color",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15431",
    "data-name": "Rectangle 15431",
    width: 37.122,
    height: 37.122,
    rx: 18.561,
    fill: "#1da1f2",
    opacity: 0.6,
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.bc5b829535a04d33b68aa4c97813b25c.svg";
export { ForwardRef as ReactComponent };